import fm from './moon-icon-full.svg'
import lq from './moon-icon-last-quarter.svg'
import fq from './moon-icon-first-quarter.svg'
import wan_gib from './moon-icon-waning-gibbous.svg'
import wax_gib from './moon-icon-waxing-gibbous.svg'
import wan_cre from './moon-icon-waning-crescent.svg'
import wax_cre from './moon-icon-waxing-crescent.svg'
import nm from './moon-icon-new.svg'
import major_fm from './moon-icon-major-full.svg'
import major_lq from './moon-icon-major-last-quarter.svg'
import major_fq from './moon-icon-major-first-quarter.svg'
import major_nm from './moon-icon-major-new.svg'


const moonIcons = {
	fm,
	lq,
	fq,
	wan_gib,
	wax_gib,
	wan_cre,
	wax_cre,
	nm,
	major_fm,
 	major_lq,
 	major_fq,
 	major_nm
}

export default moonIcons 